import { render, staticRenderFns } from "./mainDealerStock.vue?vue&type=template&id=bb8abcc0&scoped=true&"
import script from "./mainDealerStock.vue?vue&type=script&lang=js&"
export * from "./mainDealerStock.vue?vue&type=script&lang=js&"
import style0 from "./mainDealerStock.vue?vue&type=style&index=0&id=bb8abcc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8abcc0",
  null
  
)

export default component.exports